import { mutatorAction } from 'satcheljs';
export default mutatorAction('setSelectionAnchorRowKey', function setSelectionAnchorRowKey(tableView, newSelectionAnchorRowKey) {
    tableView.selectionAnchorRowKey = newSelectionAnchorRowKey;
});
//# sourceMappingURL=setSelectionAnchorRowKey.js.map